import React from "react";
import { Box } from "grid-styled";
import styled from "styled-components";
import { pink500 } from "material-ui/styles/colors";

const styles = {
  backgroundColor: "#eee",
  height: "100%",
  padding: 10,
  outline: "2px solid #ccc"
};

const Content = styled.div`
  background-color: #ddd;
  height: 100%;
`;

const DivContainer = styled.div`
  height: 50px;
  padding: 10px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  cursor: move;
  cursor: grab;
  cursor: -webkit-grab;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition-duration: 0.15s;
  transition-property: box-shadow;
  &:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.35);
  }
`;
export const Layout1 = () => (
  <DivContainer>
    <Box w={[1]} flex="0 1 auto" p={[1, 1, 1, 1]} style={styles}>
      <Content />
    </Box>
  </DivContainer>
);
export const Layout2 = () => (
  <DivContainer>
    <Box w={[1 / 2]} flex="0 1 auto" p={[1, 1, 1, 1]} style={styles}>
      <Content />
    </Box>
    <Box w={[1 / 2]} flex="0 1 auto" p={[1, 1, 1, 1]} style={styles}>
      <Content />
    </Box>
  </DivContainer>
);
export const Layout3 = () => (
  <DivContainer>
    <Box w={[1 / 3]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
    <Box w={[1 / 3]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
    <Box w={[1 / 3]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
  </DivContainer>
);
export const Layout4 = () => (
  <DivContainer>
    <Box w={[1 / 4]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
    <Box w={[3 / 4]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
  </DivContainer>
);
export const Layout5 = () => (
  <DivContainer>
    <Box w={[3 / 4]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
    <Box w={[1 / 4]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
  </DivContainer>
);
export const Layout6 = () => (
  <DivContainer>
    <Box w={[1 / 4]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
    <Box w={[1 / 4]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
    <Box w={[1 / 4]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
    <Box w={[1 / 4]} flex="0 1 auto" style={styles}>
      <Content />
    </Box>
  </DivContainer>
);

export const Layout7 = () => (
  <DivContainer>
    <Box w={[1]} flex="0 1 auto" p={[1, 1, 1, 1]} style={styles}>
      <Content
        style={{
          color: "#FFFFFF",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          backgroundColor: pink500
        }}
      >
        Row Carousel
      </Content>
    </Box>
  </DivContainer>
);

export const layoutsleft = {
  layout1: Layout1,
  layout2: Layout2,
  layout3: Layout3,
  layout4: Layout4,
  layout5: Layout5,
  layout6: Layout6,
  layout7: Layout7
};



// WEBPACK FOOTER //
// ./src/editor/layout/components/RowBox.js